import React from 'react';
import Navbar from '../components/Navbar';
import InteractiveWriting from '../components/InteractiveWriting';
import Footer from '../components/Footer';

export default function InteractiveWritingPage() {
  return (
    <>
      <Navbar />
      <InteractiveWriting />
      <Footer />
    </>
  );
}
